'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function offerRedemptionCount(stats) {
  const { redemptionCount7Day = 0, redemptionCount24Hr = 0 } = stats || {};

  let result = 0;

  if (redemptionCount24Hr * 1.5 >= 40) {
    result = Math.floor(redemptionCount24Hr * 1.5);
  } else if (redemptionCount7Day * 1.5 >= 40) {
    result = Math.floor(redemptionCount7Day * 1.5);
  }

  return result;
}

function OfferRedemptionCount({ className = '', stats }) {
  const total = offerRedemptionCount(stats);

  if (total > 0) {
    return h(
      Translate,
      { attrs: { class: className }, 0: total },
      'js.modules.redemption.UsedCountFormat'
    );
  }
}

module.exports = OfferRedemptionCount;
